import { useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useProjectHighLight = () => {

    const [data, setData] = useState([])
    const [filterValue, setFilterValue] = useState({});
    const [options, setOptions] = useState({});
    const [loader, setLoader] = useState({
        outerLoader: false,
        innerLoader: false
    })
    const [showPopup, setShowPopup] = useState({
        show: false,
        data: ""
    })
    const [expanded, setExpanded] = useState({
        clients: {},
        projects: {},
        allExpand: false
    });
    const [showDetails, setSHowDetails] = useState({
        show: false,
        data: {}
    })


    useEffect(() => {
        callautopopulate("project_glance_category").then(res => {
            setOptions(({
                clientUnitOption: res?.project_glance_category,
            }))
            setFilterValue((prev) => ({ ...prev, category: _.find(res?.project_glance_category, { client_key: "lead" })?.client_key, apiCall: true }))
        })
    }, [])

    useEffect(() => {
        if (!filterValue?.apiCall && filterValue?.category) {
            getProjectSummary();
        } else if (filterValue?.apiCall) {
            setFilterValue((prev) => ({ ...prev, apiCall: false }));
        }
    }, [filterValue?.apiCall, filterValue?.category])

    const toggleClient = (clientId) => {
        setExpanded(prev => ({
            ...prev,
            clients: {
                ...prev.clients,
                [clientId]: !prev.clients[clientId]
            }
        }));
    };

    const toggleProject = (clientId, projectId) => {
        setExpanded(prev => ({
            ...prev,
            projects: {
                ...prev.projects,
                [`${clientId}-${projectId}`]: !prev.projects[`${clientId}-${projectId}`]
            }
        }));
    };

    const handleExpand = (key) => {
        if (key === "collapse") {
            setExpanded({
                clients: {},
                projects: {},
                allExpand: false
            });
        } else if (key === "expand") {
            const allClients = {};
            data.forEach(client => {
                allClients[client.title_id] = true;
            });

            setExpanded(prev => ({
                ...prev,
                clients: allClients,
                allExpand: true
            }));
        }
    };

    const getProjectSummary = async () => {
        try {
            setLoader({ outerLoader: true })
            const payload = {
                "project_status_id": filterValue?.project_status?.project_status_id || 0,
                "project_priority_id": filterValue?.project_priority?.project_priority_id || 0,
                "grouping_type": filterValue?.category || "",
                "project_search": filterValue?.search || "",
                "lead_user_codes": _.pluck(filterValue?.project_leads, "user_code")?.toString() || "",
                "requested_user_codes": _.pluck(filterValue?.users, "user_code")?.toString() || "",
                "project_ids": _.pluck(filterValue?.projects, "project_id")?.toString() || "",
                "client_ids": _.pluck(filterValue?.client, "client_id")?.toString() || "",
                "project_portfolio_ids": _.pluck(filterValue?.project_portfolio, "project_portfolio_id")?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFOSUMMARY"), payload)
            if (!res?.body?.error_status) {
                setData(_.sortBy(res?.body?.data, "title_name"))
            } else {
                setData([])
            }
            setLoader({ outerLoader: false })
            setFilterValue((prev) => ({ ...prev, apiCall: false }))
            setExpanded({
                clients: {},
                projects: {},
                allExpand: false
            });
        } catch (error) {
            setData([])
            setLoader({ outerLoader: false })
            console.error("error", error)
        }
    }


    const getProjectList = async () => {
        try {
            const ids = Object.keys(expanded.clients).filter(id => expanded.clients[id] === true)
            if (ids?.length === 0) {
                return
            }
            setLoader({ innerLoader: true })
            const category = filterValue?.category
            const payload = {
                "project_search": filterValue?.search || "",
                "project_status_id": filterValue?.project_status?.project_status_id || 0,
                "project_priority_id": filterValue?.project_priority?.project_priority_id || 0,
                "lead_user_codes": category === "lead" ? ids?.toString() : !_.isEmpty(filterValue?.project_leads) ? _.pluck(filterValue?.project_leads, "user_code")?.toString() : "",
                "portfolio_codes": category === "portfolio" ? ids?.toString() : !_.isEmpty(filterValue?.project_portfolio) ? _.pluck(filterValue?.project_portfolio, "project_portfolio_id")?.toString() : "",
                "unit_codes": category === "unit" ? ids?.toString() : "",
                "client_codes": category === "client" ? ids?.toString() : !_.isEmpty(filterValue?.client) ? _.pluck(filterValue?.client, "client_id")?.toString() : "",
                "status_codes": category === "status" ? ids?.toString() : "",
                "project_ids": _.pluck(filterValue?.projects, "project_id")?.toString() || "",
                "requested_user_codes": _.pluck(filterValue?.users, "user_code")?.toString() || "",

            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFOLIST"), payload);
            if (!res?.body?.error_status) {
                let key
                if (category === "client") {
                    key = "client_id"
                } else if (category === "portfolio") {
                    key = "project_portfolio_id"
                } else if (category === "status") {
                    key = "project_status_id"
                } else if (category === "lead") {
                    key = "project_lead_user_code"
                }
                const updatedTitles = data?.map(title => {
                    const matchingProjects = res?.body?.data?.project_info_list
                        ?.filter(project => {
                            const projectValue = project[key];
                            if (typeof projectValue === 'string') {
                                return projectValue.includes(title.title_id);
                            }
                            return projectValue === title.title_id;
                        })
                        ?.map(project => ({
                            ...project,
                            title_name: title.title_name
                        })) || [];
                    return {
                        ...title,
                        projects: matchingProjects?.sort((a, b) => a?.project_name?.localeCompare(b?.project_name))
                    };
                });
                setData(updatedTitles)
            }
            setLoader({ innerLoader: false })
        } catch (error) {
            setLoader({ innerLoader: false })
            console.error(error)
        }
    }

    const prevActiveCountRef = useRef(0);

    useEffect(() => {
        const currentCount = Object.values(expanded.clients).filter(Boolean).length;

        if (currentCount > prevActiveCountRef.current && currentCount > 0) {
            getProjectList();
        }

        prevActiveCountRef.current = currentCount;
    }, [expanded.clients]);



    const getProjectStatusColor = (status, name) => {
        if (status === "in_progress" || status === "active") {
            return <spna className="rounded-pill px-2 fw-semiold" style={{ color: "#1e40af", background: "#dbeafe", border: "1px solid #93c5fd" }}>{name}</spna>
        }
        else if (status === "completed" || status === "closed") {
            return <spna className="rounded-pill px-2 fw-semiold" style={{ color: "#166534", background: "#dcfce7", border: "1px solid #86efac" }}>{name}</spna>
        }
        else if (status === "maintanance" || status === "hold") {
            return <spna className="rounded-pill px-2 fw-semiold" style={{ color: "#525252", background: "#eeebeb", border: "1px solid #525252" }}>{name}</spna>
        } else if (status === "not_started" || status === "new") {
            return <spna className="rounded-pill px-2 fw-semiold" style={{ color: "#991b1b", background: "#fee2e2", border: "1px solid #fca5a5" }}>{name}</spna>
        } else {
            return
        }
    }



    return useMemo(() => ({
        data, expanded, toggleClient, toggleProject, handleExpand, showPopup, setShowPopup, loader, filterValue, setFilterValue, getProjectSummary, getProjectStatusColor, setSHowDetails, options, setExpanded
    }), [data, expanded, toggleClient, toggleProject, handleExpand, showPopup, setShowPopup, loader, filterValue, setFilterValue, getProjectSummary, getProjectStatusColor, setSHowDetails, options, setExpanded])
}